var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Library Imports
import { useRef } from "react";
import VTRichTextEditorContent from "../VTRichTextEditor/VTRichTextEditorContent";
import ReactAudioPlayer from "react-audio-player";
// MUI Imports
import { Box } from "@mui/material";
// Model Imports
import { EContentDataType } from "../../models/hotspot.model";
export default function VTHotspotContent(_a) {
    var content = _a.content, currentTarget = _a.currentTarget, contentActive = _a.contentActive, setContentActive = _a.setContentActive, setCurrentTarget = _a.setCurrentTarget, moveableRef = _a.moveableRef, handleUpdateContent = _a.handleUpdateContent, viewer = _a.viewer;
    var inputRef = useRef();
    // useEffect(() => {
    //     if (currentTarget === content.id && contentActive) {
    //         inputRef.current?.focus();
    //     }
    // }, [currentTarget, contentActive]);
    return (_jsxs(Box, __assign({ component: "div", className: "target-".concat(content.id), onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log("stopped!");
        }, onDoubleClick: function () {
            var _a;
            if (setContentActive && currentTarget === content.id && contentActive) {
                setContentActive(true);
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }, onBlur: function () {
            if (setContentActive) {
                setContentActive(false);
            }
        }, sx: {
            cursor: contentActive || viewer ? "auto" : "move",
            maxHeight: "100%",
            overflowWrap: "break-word",
            maxWidth: "".concat(content.positionData.width, "px"),
            position: "absolute",
            top: "".concat(content.positionData.top, "px"),
            left: "".concat(content.positionData.left, "px"),
            rotate: "".concat(content.positionData.rotation, "deg"),
            fontSize: "10px",
        } }, { children: [content.type === EContentDataType.HTML && (_jsx(VTRichTextEditorContent, { sx: { lineHeight: 1.2 }, ref: inputRef, 
                // TODO: rename
                startingHtmlContent: content.content, viewer: viewer, rteId: "rich-text-editor-".concat(content.id), onClick: function (e) {
                    var _a, _b;
                    if (viewer) {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    if (setCurrentTarget) {
                        setCurrentTarget(content.id);
                    }
                    if (!contentActive) {
                        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    }
                    else {
                        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                }, onBlur: function () {
                    if (setContentActive) {
                        setContentActive(false);
                    }
                }, onChange: function (htmlStringContent) {
                    console.log("content updating", htmlStringContent);
                    if (moveableRef && moveableRef.current && handleUpdateContent) {
                        moveableRef.current.updateRect();
                        handleUpdateContent(htmlStringContent, content.id);
                    }
                } })), content.type === EContentDataType.IMAGE && (_jsx("img", { src: content.content, alt: "blob", width: "100%", height: "100%", style: { objectFit: "contain" }, draggable: false, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (setCurrentTarget) {
                        setCurrentTarget(content.id);
                    }
                    if (setContentActive) {
                        setContentActive(false);
                    }
                } })), content.type === EContentDataType.VIDEO && (_jsx("video", { src: content.content, width: "100%", height: "100%", controls: contentActive || viewer, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (setCurrentTarget) {
                        setCurrentTarget(content.id);
                    }
                } })), content.type === EContentDataType.AUDIO && (_jsx(ReactAudioPlayer, { style: {
                    width: "100%",
                    height: "100%",
                }, controls: true, controlsList: "nodownload noplaybackrate", src: content.content }))] })));
}
